import ServiceTemplate from '@/components/ServiceTemplate';

export default function GoodStanding() {
  const data = {
    title: 'Certificate of Good Standing Services',
    subtitle: 'Obtain certificates of good standing and resolve compliance issues.',
    overviewTitle: 'What is a Certificate of Good Standing?',
    overviewImage: 'https://images.unsplash.com/photo-1758873268131-a2636b120d81',
    description: [
      'A Certificate of Good Standing (also called Certificate of Existence or Certificate of Status) is an official document issued by the state confirming your business is properly registered and current with all filing requirements.',
      'These certificates are commonly required for business loans, opening business bank accounts, entering contracts, registering in other states, and various business transactions.',
      'We obtain certificates of good standing, resolve any outstanding compliance issues preventing issuance, and provide expedited service when time is critical.'
    ],
    benefits: [
      { title: 'Quick Turnaround', description: 'Fast certificate acquisition with expedited options.' },
      { title: 'Compliance Resolution', description: 'Resolve any issues preventing certificate issuance.' },
      { title: 'Multi-State Service', description: 'Obtain certificates from multiple states.' },
      { title: 'Official Documentation', description: 'Receive official state-issued certificates.' },
      { title: 'Expert Guidance', description: 'Professional handling of compliance matters.' },
      { title: 'Ongoing Support', description: 'Assistance with maintaining good standing.' }
    ],
    process: [
      { title: 'Assessment & Planning', description: 'Evaluate current status and plan all necessary steps for successful completion.' },
      { title: 'Documentation & Filing', description: 'Prepare and file all required documents with state and federal authorities.' },
      { title: 'Verification & Finalization', description: 'Ensure proper processing, obtain confirmations, and finalize all requirements.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential formation',
        price: '$299',
        period: '+ state fees',
        features: [
          'Entity formation filing',
          'Name availability check',
          'EIN application',
          'Basic documents',
          'Email support',
          'Document delivery'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete package',
        price: '$599',
        period: '+ state fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Custom agreements',
          'Tax consultation',
          'Compliance setup',
          'Registered agent (1 year)',
          'Priority processing',
          'Phone support'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Full-service solution',
        price: '$999',
        period: '+ state fees',
        features: [
          'Everything in Professional',
          'Multi-state filing',
          'Advanced structuring',
          'Annual compliance',
          'Quarterly reviews',
          'Dedicated attorney',
          'Unlimited consultations'
        ]
      }
    ],
    faqs: [
      { question: 'When do I need a Certificate of Good Standing?', answer: 'Certificates are commonly required for bank loans, opening accounts, foreign qualification, contracts, and business transactions.' },
      { question: 'How long is a certificate valid?', answer: 'Validity varies by use, typically 30-90 days. Recipients often require recently issued certificates.' },
      { question: 'What if my business isn\'t in good standing?', answer: 'We identify outstanding issues (missed reports, unpaid fees) and help resolve them to obtain the certificate.' },
      { question: 'How long does it take to get a certificate?', answer: 'Standard processing is 3-10 business days depending on state; expedited service is available in most states for additional fees.' },
      { question: 'Can I get a certificate online?', answer: 'Some states offer online certificates, while others require mail requests. We handle the process regardless of state requirements.' },
      { question: 'What information is on the certificate?', answer: 'Certificates typically include entity name, formation date, jurisdiction, current status, and confirmation of compliance with state requirements.' },
      { question: 'Do I need certificates from multiple states?', answer: 'If registered to do business in multiple states (foreign qualification), you may need certificates from each jurisdiction.' },
      { question: 'How much does a certificate cost?', answer: 'State fees range from $10-$50 per certificate, plus expedite fees if needed and our service fee.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
